import { useMutation } from '@tanstack/react-query'
import { ApiStudentRequest, request } from '../utils/request'
import { NewProfileResource, ProfileResource } from '@backend/resources/profile'
import { LegalDocumentRequest } from '@backend/resources/policy-agreement/types'

type SignUpParams = NewProfileResource['attributes'] & {
  included: LegalDocumentRequest
}

type RawProfilesResponse = {
  data: ProfileResource
}

export function useSignUp() {
  const { isPending, mutate } = useMutation({
    mutationFn: async (params: SignUpParams) => {
      return await request<RawProfilesResponse>(
        new ApiStudentRequest('/profiles', {
          method: 'POST',
          body: {
            data: {
              type: 'profile',
              attributes: {
                givenName: params.givenName,
                familyName: params.familyName,
                email: params.email,
                included: params.included,
              },
            },
          },
        }),
        {
          isExpectedResponse: (res): res is RawProfilesResponse => res as boolean,
        },
      )
    },
  })

  return {
    isSigningUp: isPending,
    signUp: mutate,
  }
}
